module.exports = __webpack_public_path__ + "static/img-1105637fb00d70896dda6a4c2b94ea5b.jpeg";